import React, { useEffect, useState } from 'react';
import SuccessProjectPopup from '../SuccessProjectPopup/SuccessProjectPopup';
import classes from './FilesPopup.module.css';

const FilesPopup = ({ fileUrl, title, setMessage }) => {

  const [isImage, setIsImage] = useState(false);
  const [url, setUrl] = useState()

  useEffect(() => {
    setUrl(fileUrl)
    checkFile(fileUrl)
  }, [fileUrl])

  const checkFile = (url) => {

    const fileExtension = url.split('.').at(-1);
    switch (fileExtension?.toLowerCase()) {
      case 'gif':
      case 'jpeg':
      case 'png':
      case 'jpg':
        setIsImage(true);
        setUrl(url)
        break;
      case 'ppt':
      case 'pptx':
      case 'doc':
      case 'docx':
      case 'xls':
      case 'xlsx':
        setUrl(`https://view.officeapps.live.com/op/embed.aspx?embedded=true&src=${url}`);
        setIsImage(false);
        break;
      case 'csv':
      case 'xml':
        setUrl(`https://docs.google.com/viewer?url=${url}&embedded=true`)
        setIsImage(false);
        break;
      default: break;
    }
  }

  return (
    <SuccessProjectPopup close={() => setMessage(false)} color="#CCF0F085" title={title} myWidth='1082px' myHeight='592px'>
      {isImage ?
        <img className={classes.Image} src={url} alt="FilesPopup" /> :
        <iframe src={url} height="100%" width="100%" frameBorder={0} className={classes.Iframe} title="FilesPopup" />
      }
    </SuccessProjectPopup>
  );
};

export default FilesPopup;